import { KendoGrid, RefreshKendoGrid } from "../../Kendo/kendo_grid";
import { baseURL, post } from "../../Util/axios_helper";
import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  ErrorMsg,
  GetFormData,
  ValidateForm,
  checkAccess,
  confirmDelete,
} from "../../Util/common";
export const GoogleFeedback = () => {
  const onSubmit = async (e) => {
    e.preventDefault();
    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else {
      let data = GetFormData(e);
      await post("Feedback/UpdateGoogleFeedBack", data);
      RefreshKendoGrid("Googlefeedback");
      $("#update-google").modal("hide");
      clearForm();
    }
  };
  const [error, setError] = useState({});
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const [event, setEvent] = useState({
    Id: 0,
    EventNumber: "",
  });
  const handleEditClick = async (e) => {
    setEvent({
      Id: e.Id,
      EventNumber: e.EventNumber,
    });

    $("#update-google").modal("show");
  };
  const clearForm = () => {
    setEvent({
      Id: 0,
      EventNumber: "",
      
    });
    setError({});
    $("#btn-reset").click();
  };
  return (
    <>
      <KendoGrid
      exportFileName={"GoogleFeedbackReport"}
        name={"Googlefeedback"}
        url={baseURL + "Feedback/GetGoogleFeedback"}
        schema={{}}
        columns={[
          {
            field: "Id",
            filterable: false,
            hidden: true,
          },
          {
            field: "EventNumber",
            title: "Event No",
            width: 60,
          },
          {
            field: "ReviewerName",
            title: "Reviewer Name",
            width: 90,
          },
          {
            field: "StarRating",
            title: "Star Rating",
            width: 60,
          },
          {
            field: "ReviewerComment",
            title: "Comment",
            width: 200,
          },
          {
            field: "ReviewCreateTime",
            title: "Review Date",
            width: 60,
          },
        ]}
        showOptions={true}
        showEdit={true}
        showDelete={false}
        scrollable={true}
        height={"60vh"}
        onEditClick={handleEditClick}
      />
      {/* <!-- Update Google Feedback Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update-google"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Google FeedBack</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-update-review" onSubmit={onSubmit}>
                <input type="hidden" name="Id" value={event.Id} />
                <input type="hidden" name="Type" value={event.Type} />
                <div className="row input-block mb-3">
                  <div className="col-md-12">
                    <label className="form-label">
                      Event Number<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={100}
                      className="form-control field"
                      name="EventNumber"
                      defaultValue={event.EventNumber}
                      placeholder="Event Number"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("TypeName", e.target.value);
                      }}
                    />
                    {error.EventNumber && (
                      <ErrorMsg text="Event Number is required" />
                    )}
                  </div>
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button name={"Save"} />
                  <button
                    type="reset"
                    id="btn-reset"
                    style={{ display: "none" }}
                  ></button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Update Formal Feedback Modal --> */}
    </>
  );
};
